// 77 Thai province names used as `area` query values on the public NHSO
// dashboard. MUST stay in sync (spelling + membership) with the backend list in
// dent-cloud-service/src/constants/thaiGeo.js (PROVINCES = keys of the zone map,
// in zone 1 -> 13 order) — these strings are sent verbatim as the `area` filter.
export const PROVINCES = [
  // เขต 1
  "เชียงใหม่", "เชียงราย", "ลำปาง", "ลำพูน", "แพร่", "น่าน", "พะเยา", "แม่ฮ่องสอน",
  // เขต 2
  "พิษณุโลก", "ตาก", "เพชรบูรณ์", "สุโขทัย", "อุตรดิตถ์",
  // เขต 3
  "นครสวรรค์", "กำแพงเพชร", "พิจิตร", "อุทัยธานี", "ชัยนาท",
  // เขต 4
  "สระบุรี", "นนทบุรี", "ปทุมธานี", "พระนครศรีอยุธยา", "อ่างทอง", "ลพบุรี", "สิงห์บุรี", "นครนายก",
  // เขต 5
  "ราชบุรี", "กาญจนบุรี", "นครปฐม", "สุพรรณบุรี", "ประจวบคีรีขันธ์", "เพชรบุรี", "สมุทรสงคราม", "สมุทรสาคร",
  // เขต 6
  "ชลบุรี", "ระยอง", "จันทบุรี", "ตราด", "สมุทรปราการ", "ฉะเชิงเทรา", "ปราจีนบุรี", "สระแก้ว",
  // เขต 7
  "ขอนแก่น", "กาฬสินธุ์", "มหาสารคาม", "ร้อยเอ็ด",
  // เขต 8
  "อุดรธานี", "เลย", "หนองคาย", "หนองบัวลำภู", "บึงกาฬ", "นครพนม", "สกลนคร",
  // เขต 9
  "นครราชสีมา", "ชัยภูมิ", "บุรีรัมย์", "สุรินทร์",
  // เขต 10
  "อุบลราชธานี", "ศรีสะเกษ", "ยโสธร", "อำนาจเจริญ", "มุกดาหาร",
  // เขต 11
  "สุราษฎร์ธานี", "ชุมพร", "นครศรีธรรมราช", "พังงา", "ภูเก็ต", "ระนอง", "กระบี่",
  // เขต 12
  "สงขลา", "สตูล", "ตรัง", "พัทลุง", "ปัตตานี", "ยะลา", "นราธิวาส",
  // เขต 13
  "กรุงเทพมหานคร",
];

export default PROVINCES;
